import React, {Fragment} from 'react';
import {useSelector} from 'react-redux';
import PropTypes from 'prop-types';
import TEMaterialityDisplayNumber from './TEMaterialityDisplayNumber';

/* This component was made to refactor TEMateriality inner function. */
function TEMaterialityDisplayCurrentPercentage({teAmountValue, pmAmountValue, isCurrentTe}) {
	const featureConfigurations = useSelector((store) => store.configurations);
	const roundValue = Math.round((teAmountValue / pmAmountValue) * 100);

	const teRoundingBufferPercentage =
		featureConfigurations?.features?.materialityTERationaleRoundingBufferPercentage ?? 5;

	const teRoundingBufferValue = Math.round((teRoundingBufferPercentage / 100) * roundValue);

	// If result is between 49% and 51%, show 50%
	if (roundValue && roundValue >= 49 - teRoundingBufferValue && roundValue <= 51 + teRoundingBufferValue) {
		return <TEMaterialityDisplayNumber value={50} suffix={'%'} isDecimal={false} />;
	}

	// If result is between 74% and 76%, show 75%
	if (roundValue && roundValue >= 74 - teRoundingBufferValue && roundValue <= 76 + teRoundingBufferValue) {
		return <TEMaterialityDisplayNumber value={75} suffix={'%'} isDecimal={false} />;
	}

	return (
		<Fragment>
			{isCurrentTe ? (
				<TEMaterialityDisplayNumber value={roundValue} suffix={'%'} isDecimal={false} />
			) : (
				<TEMaterialityDisplayNumber value={''} suffix={''} isDecimal={false} />
			)}
		</Fragment>
	);
}

TEMaterialityDisplayCurrentPercentage.propTypes = {
	teAmountValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	pmAmountValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	isCurrentTe: PropTypes.bool
};

export default TEMaterialityDisplayCurrentPercentage;
